import rootLogger from '../utils/logger';

const logger = rootLogger.extend('cache');

export default logger;
